import * as React from "react"
import type { SVGProps } from "react"
const SvgGlobe = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M12 22.29a10 10 0 0 1-3.9-.8 10 10 0 0 1-3.17-2.13 10 10 0 0 1-2.14-3.17 10 10 0 0 1-.79-3.9q0-2.09.79-3.9A10 10 0 0 1 4.92 5.2Q6.28 3.86 8.1 3.07A10 10 0 0 1 12 2.3q2.07 0 3.9.78a10 10 0 0 1 3.18 2.14q1.34 1.35 2.13 3.18a10 10 0 0 1 .79 3.9 10 10 0 0 1-.79 3.9 10 10 0 0 1-2.14 3.17q-1.34 1.35-3.17 2.14a10 10 0 0 1-3.9.78m-1-2.05v-1.95q-.82 0-1.41-.6A2 2 0 0 1 9 16.3v-1l-4.8-4.8-.14.9q-.06.45-.06.9a7.8 7.8 0 0 0 1.99 5.3A7.7 7.7 0 0 0 11 20.24m6.9-2.55a9 9 0 0 0 1.56-2.52A8 8 0 0 0 20 12.3a8 8 0 0 0-1.36-4.48A7.7 7.7 0 0 0 15 4.9v.4q0 .83-.59 1.4a2 2 0 0 1-1.41.6h-2v2q0 .43-.29.7a1 1 0 0 1-.71.3H8v2h6a.97.97 0 0 1 1 1v3h1q.65 0 1.18.38.53.39.72 1.02" />
  </svg>
)
export default SvgGlobe
